var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_24178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16675C12.5 2.78604 11.3807 1.66675 10 1.66675C8.61929 1.66675 7.5 2.78604 7.5 4.16675V9.16675C7.5 10.5475 8.61929 11.6667 10 11.6667C11.3807 11.6667 12.5 10.5475 12.5 9.16675V4.16675Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.50008V4.16675M0.833332 1.66675V5.00008M15.8333 2.50008V4.16675M19.1667 1.66675V5.00008M4.16667 8.33341V9.16675C4.16667 10.7138 4.78125 12.1976 5.87521 13.2915C6.96917 14.3855 8.4529 15.0001 10 15.0001M10 15.0001C11.5471 15.0001 13.0308 14.3855 14.1248 13.2915C15.2188 12.1976 15.8333 10.7138 15.8333 9.16675V8.33341M10 15.0001V18.3334M10 18.3334H7.5M10 18.3334H12.5",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_24178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.e6c079c8ea42b471f970b8912cfd449a.svg";
export { ForwardRef as ReactComponent };